// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"history_pageContainer__lLrp6","ProductBuyingHeader":"history_ProductBuyingHeader__2w1wI","statesHeader":"history_statesHeader__3cRpM"};